import { combineReducers } from "redux";
import settings from "./settings/Reducer";
import CustomizerReducer from '../store/customizer/CustomizerSlice';
const Reducers = combineReducers({
  settings,
  customizer: CustomizerReducer,
});

export default Reducers;
